import React from 'react';
import SectionBundleReceiptEntry from '../SectionBundleReceiptEntry';

const UnassortedBundleReceiptEntry = () => {
  return (
    <SectionBundleReceiptEntry
      sectionName="Unassorted"
      sectionDisplayName="Unassorted Section"
      backRoute="/sections/unassorted"
    />
  );
};

export default UnassortedBundleReceiptEntry;
